const style = () => ({
    switchContainer: {

    }
});
export default style;